/**
 * 示例
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/iam',
  items: [
    // 用户信息
    { key: 'getUserInfo', url: '/skyer/v1/users/self', method: 'get',loadingHide: true },
    { key: 'getClientCode', url: '/skyer/v1/{organizationId}/user/clientCode/{cusId}', method: 'get' },
    // 用户菜单权限  获取当前用户树形菜单
    {
      key: 'getUserMenuTree',
      url: '/v1/sys/menu/manage/user/tree',
      method: 'get',
      loadingHide: true,
    },
    // 初始化菜单（仅第一次调用）
    {
      key: 'initMenuTree',
      url: '/v1/sys/menu/manage/menu/init',
      method: 'POST',
    },
    // 创建菜单
    {
      key: 'addMenuTree',
      url: '/v1/sys/menu/manage/menu/create',
      method: 'POST',
    },
    // 删除菜单
    {
      key: 'deleteMenuTree',
      url: '/v1/sys/menu/manage/menu/delete',
      method: 'POST',
    },
    // 批量删除菜单
    {
      key: 'batchDeleteMenuTree',
      url: '/v1/sys/menu/manage/menu/batch/delete',
      method: 'POST',
    },
    // 修改菜单
    {
      key: 'updateMenuTree',
      url: '/v1/sys/menu/manage/menu/update',
      method: 'POST',
    },

    /**
     * 用户管理-分页查询
     *  @organizationId : 0
     */
    { key: 'getUserList', url: '/skyer/v1/{organizationId}/users/paging', method: 'get',loadingHide: true, },
    /**
     * 用户管理-修改密码
     *  @organizationId : 0
     *  @userId : 194783206599467008
     */
    {
      key: 'adminUpdatePassword',
      url: '/skyer/v1/{organizationId}/users/{userId}/admin-password',
      method: 'PUT',
      type: 'BODY',
    },
    /**
     * 用户管理-创建用户
     *  @organizationId : 0
     */
    {
      key: 'createUser',
      url: '/skyer/v1/{organizationId}/users',
      method: 'POST',
    },

    /**
     * 用户管理-新增客户
     *  @organizationId : 0
     */
    {
      key: 'createCustomer',
      url: '/skyer/v1/{organizationId}/customer',
      method: 'POST',
    },
    {
      key: 'createCustomerOnboarding',
      url: '/skyer/v1/{organizationId}/customerOnboarding',
      method: 'POST',
    },

    /**
     * 获取用户板数
     *
     */
    {
      key: 'getCustomerPalletPageList',
      url: '/skyer/v1/{organizationId}/customer/pallet/pageList',
      method: 'POST'
    },
    // 更新
    {
      key: 'validUpdateCustomerPallet',
      url: '/skyer/v1/{organizationId}/customer/pallet/validUpdate',
      method: 'POST'
    },
    // 日志
    {
      key: 'getCustomerPalletLog',
      url: '/skyer/v1/{organizationId}/customer/palletLog/{cusId}',
      method: 'GET'
    },

    /**
     * 用户管理-根据id查询用户信息
     *  @organizationId : 0
     *  @userId
     */
    {
      key: 'getUserInfoById',
      url: '/skyer/v1/{organizationId}/users/{userId}/info',
      method: 'GET',
    },

    /**
     * 用户管理- 子账户 - 根据id查询所有分配给用户的角色
     *  @organizationId : 0
     *  @userId
     */
    {
      key: 'getUserAllRolesById',
      url: '/skyer/v1/{organizationId}/member-roles/user-all-roles/{userId}',
      method: 'GET',
    },
    /**
     * 用户管理- 角色管理 - 批量删除用户的角色
     *  @organizationId : 0
     *  @userId
     */
    {
      key: 'deleteUserRoles',
      url: '/skyer/v1/{organizationId}/member-roles/batch-delete',
      method: 'DELETE',
    },
    /**
     * 用户管理- 角色管理 - 批量分配成员角色
     *  @organizationId : 0
     *  @userId
     */
    {
      key: 'addUserRoles',
      url: '/skyer/v1/{organizationId}/member-roles/batch-assign',
      method: 'POST',
    },

    /**
     * 用户管理 - 修改用户
     *  @organizationId : 0
     */
    {
      key: 'updateUserInfo',
      url: '/skyer/v1/{organizationId}/users',
      method: 'PUT',
      type: 'BODY',
    },

    /** *************** 个人中心 ******************* */

    /**
     * 登录用户 - 修改自己的密
        {
          "organizationId": 0,
          "originalPassword": "string",
          "password": "string"
        }
     */
    {
      key: 'updateMyPassword',
      url: '/skyer/v1/users/password',
      method: 'PUT',
      type: 'BODY',
    },
    /**
     * 登录用户 - 更改名称
     * @realName
     */
    {
      key: 'updateMyRealName',
      url: '/skyer/v1/users/real-name',
      method: 'PUT',
      type: 'Query',
    },
    /**
     * 登录用户 - 更改头像
     * @avatar
     */
    {
      key: 'updateMyAvatar',
      url: '/skyer/v1/users/avatar',
      method: 'PUT',
      type: 'query',
    },
    /**
     * 登录用户 - 前置密码校验
     * @password
     * @ResponseBody  {lastCheckKey}
     */
    {
      key: 'checkMyPassword',
      url: '/skyer/v1/users/password/pre-validate',
      method: 'GET',
    },
    /**
     * 登录用户 - 给新手机号发送验证码
     * @lastCheckKey
     * @phone
     * @ResponseBody    "captchaKey", "message" , "interval": 60
     */
    {
      key: 'sendCaptchaByPhone',
      url: '/skyer/v1/users/phone-new/send-captcha',
      method: 'GET',
    },
    /**
     * 登录用户 - 新手机号验证码验证并修改手机
     * @lastCheckKey  前置密码校验返回的
     * @captchaKey    给新手机号发送验证码返回的
     * @captcha       手机接收的验证码
     * @phone         手机号
     */
    {
      key: 'checkCaptchaByPhone',
      url: '/skyer/v1/users/phone-new/validate-captcha',
      method: 'GET',
    },

    /**
     * 登录用户 - 给新邮箱发送验证码
     * @lastCheckKey
     * @email
     * @ResponseBody    "captchaKey", "message" , "interval": 60
     */
    {
      key: 'sendCaptchaByEmail',
      url: '/skyer/v1/users/email-new/send-captcha',
      method: 'GET',
    },
    /**
     * 登录用户 - 新邮箱验证码验证并修改邮箱
     * @lastCheckKey  前置密码校验返回的
     * @captchaKey    给新邮箱发送验证码返回的
     * @captcha       邮箱接收的验证码
     * @email         邮箱号
     */
    {
      key: 'checkCaptchaByEmail',
      url: '/skyer/v1/users/email-new/validate-captcha',
      method: 'GET',
    },
    /**
     * 查询用户公司的 ids
     */
    {
      key: 'getUserCompany',
      url: '/skyer/v1/users/{userId}/company',
      method: 'GET',
    },
    // 启用用户
    {
      key: 'userNnfrozen',
      url: '/skyer/v1/{organizationId}/users/{userId}/unfrozen',
      method: 'POST',
    },
    // 禁用用户
    {
      key: 'userFrozen',
      url: '/skyer/v1/{organizationId}/users/{userId}/frozen',
      method: 'POST',
    },
    // 冻结用户
    {
      key: 'userCustomerLocked',
      url: '/skyer/v1/{organizationId}/customer/locked/{cusId}',
      method: 'GET',
    },
    // 解冻用户
    {
      key: 'userCustomerNnlocked',
      url: '/skyer/v1/{organizationId}/customer/unlocked',
      method: 'POST',
    },
    // 锁定用户
    {
      key: 'userLocked',
      url: '/skyer/v1/{organizationId}/users/{userId}/locked',
      method: 'POST',
    },
    // 解锁用户
    {
      key: 'userUnlocked',
      url: '/skyer/v1/{organizationId}/users/{userId}/unlocked',
      method: 'POST',
    },
    // 离场用户
    {
      key: 'userLeave',
      url: '/skyer/v1/{organizationId}/customer/{cusId}/departure',
      method: 'POST',
    },
    // 返场用户
    {
      key: 'userBack',
      url: '/skyer/v1/{organizationId}/customer/{cusId}/unDeparture',
      method: 'POST',
    },
    // 删除用户
    {
      key: 'deleteUser',
      url: '/skyer/v1/{organizationId}/users/{userId}/delete',
      method: 'DELETE',
    },
    // 查询运输方式列表
    {
      key: 'getShippingList',
      url: '/skyer/v1/shipping/{organizationId}/list',
      method: 'POST',
      loadingHide: true,
    },
    // 修改运输方式
    {
      key: 'updateShippingList',
      url: '/skyer/v1/shipping/{organizationId}/update',
      method: 'POST',
    },

    // 当前用户 - 查询登录用户当前租户下的角色
    { key: 'getSelfRoles', url: '/skyer/v1/member-roles/self-roles', method: 'GET',loadingHide: true, },
    // 当前用户 - 切换到其它角色
    { key: 'changeRole', url: '/v1/users/roles?roleId={roleId}', method: 'PUT' },
    // 当前用户 - 切换到其它租户 tenantId
    { key: 'changeTenant', url: '/v1/users/tenant-id', method: 'PUT', type: 'query' },
    // 获取操作部门列表 - /iam/skyer/v1/dept/{organizationId}/list
    { key: 'getDepartmentList', url: '/skyer/v1/dept/{organizationId}/list', method: 'POST' },
    // 获取操作部门列表(分页) - /iam/skyer/v1/dept/{organizationId}/pageList
    { key: 'getDepartmentPageList', url: '/skyer/v1/dept/{organizationId}/pageList', method: 'POST' },
    // 新增操作部门列表 - post /skyer/v1/dept/{organizationId}/add
    { key: 'addDepartmentPageList', url: '/skyer/v1/dept/{organizationId}/add', method: 'POST' },
    // 修改操作部门列表 - post /skyer/v1/dept/{organizationId}/modify
    { key: 'modifyDepartmentPageList', url: '/skyer/v1/dept/{organizationId}/modify', method: 'POST' },
    // 群发邮件列表
    { key: 'MassconfigurationList', url: '/v1/{organizationId}/mass/configurationList', method: 'POST' },
    // 群发邮件添加
    { key: 'massassAdd', url: '/v1/{organizationId}/mass/massAdd', method: 'POST' },

    // 客户文件 - 列表
    { key: 'getUserfileList', url: '/skyer/v1/{organizationId}/userfile/list', method: 'POST' },
    // 客户文件详情 - 列表
    { key: 'getUserfileDetailsList', url: '/skyer/v1/{organizationId}/userfile/details/list', method: 'POST' },
    // 客户文件详情 - 新增
    { key: 'addUserfileDetailsList', url: '/skyer/v1/{organizationId}/userfile/details/add', method: 'POST' },
    // 客户文件详情 - 删除
    { key: 'delUserfileDetailsList', url: '/skyer/v1/{organizationId}/userfile/details/modify', method: 'POST' },

    // 用户管理 - 查询岗位列表分页
    { key: 'getStationPage', url: '/skyer/v1/station/{organizationId}/pageList', method: 'POST' },
    // 用户管理 - 新增岗位
    { key: 'addStation', url: '/skyer/v1/station/{organizationId}/add', method: 'POST' },
    // 用户管理 - 修改/删除岗位
    { key: 'modifyStation', url: '/skyer/v1/station/{organizationId}/modify', method: 'POST' },
    // 开支管理 - 列表       post /skyer/v1/expense/{organizationId}/pageList
    { key: 'getExpenseMangList', url: '/skyer/v1/expense/{organizationId}/pageList', method: 'POST' },
    // 开支管理 - 新增       post /skyer/v1/expense/{organizationId}/add
    { key: 'addExpenseMangList', url: '/skyer/v1/expense/{organizationId}/add', method: 'POST' },
    // 开支管理 - 修改、删除  post /skyer/v1/expense/{organizationId}/modify
    { key: 'modifyExpenseMangList', url: '/skyer/v1/expense/{organizationId}/modify', method: 'POST' },


    // 用户账号强制下线 - post /skyer/v1/{organizationId}/users/batchOffline
    { key: 'userBatchOffline', url: '/skyer/v1/{organizationId}/users/batchOffline', method: 'POST' },
    // 获取用户列表
    { key: 'getUsersList', url: '/skyer/v1/{organizationId}/usenet-groups-deploy/{userId}', method: 'GET', loadingHide: true },
    
    // 客户管理-生成APIkey   get /skyer/v1/{organizationId}/customer/generateApiKey/{cusId}
    { key: 'generateApiKey', url: '/skyer/v1/{organizationId}/customer/generateApiKey/{cusId}', method: 'GET' },
  ],
};

export default {
  ...generate(config),
};
